<template>
  <button class="payment-button" :class="className" v-on:click="onClick">
    <span class="label">{{label}}</span>
    <slot name="modal"><ModalOrder v-if="isShowingModal" :heading="modalHeading" :giveAway="giveAway" :title="modalTitle" :copy="modalCopy" :product="product" :show="isShowingModal" @close="isShowingModal = false" /></slot>
  </button>
</template>

<script>
import ModalOrder from '@/components/models/ModalOrder'

export default {
  name: 'PaymentButton',
  components: {
    ModalOrder
  },
  props: {
    modalTitle: String,
    modalHeading: String,
    modalCopy: String,
    label: {
      type: String,
      default: 'Buy'
    },
    // See: https://stripe.com/docs/stripe-js/reference#element-option
    product: {
      type: Object,
      required: true,
      validator: function (value) {
        return typeof value.amount === 'number' &&
        typeof value.label === 'string' &&
        typeof value.orderType === 'string'
      }
    },
    className: {
      type: String,
      default: 'btn btn-primary btn-block'
    },
    giveAway: Boolean,
    disabled: Boolean
  },
  data: function () {
    return {
      isShowingModal: false
    }
  },
  methods: {
    onClick: function () {
      this.isShowingModal = true
      this.$emit('onClick', this.product)
    }
  }
}
</script>

<style scoped>

</style>
 


// WEBPACK FOOTER //
// src/components/elements/PaymentButton.vue